import { ServiceType } from "@agroyaar/sdk";
import { reportColor } from "../../../utils/report-color";
import { reportLogo } from "../../../utils/report-logo";
import { reportTitle } from "../../../utils/report-title";

interface IntroProps {
  serviceType: ServiceType;
  introDes?: JSX.Element;
}

function Intro({ serviceType, introDes }: IntroProps) {
  const reportColorCode = reportColor(serviceType);
  const headerTitle = reportTitle(serviceType);
  const srcLogo = reportLogo(serviceType);

  return (
    <>
      <p className="text-[#222] text-[32px] font-bold text-center !font-[B-Nazanin] mt-[10px] [text-shadow:0px_2px_4px_rgba(0,0,0,0.25)]">
        کشاورزی{" "}
        <span
          className={`text-[${reportColorCode}] !font-[B-Nazanin] text-[32px]`}
        >
          مطمئن‌
          <span className="text-[#222] !font-[B-Nazanin] text-[32px]">
            تر،{" "}
          </span>
        </span>
        <span
          className={`text-[${reportColorCode}] !font-[B-Nazanin] text-[32px]`}
        >
          دقیق‌
          <span className="text-[#222] !font-[B-Nazanin] text-[32px]">
            تر و{" "}
          </span>
        </span>
        <span
          className={`text-[${reportColorCode}] !font-[B-Nazanin] text-[32px]`}
        >
          اقتصادی‌
          <span className="text-[#222] !font-[B-Nazanin] text-[32px]">تر</span>
        </span>
        {serviceType !== "EXPERIMENT" && (
          <span className="text-black font-semibold text-[18px] whitespace-nowrap block !font-[B-Nazanin]">
            هدف ما تصمیم‌گیری برای کشاورز نیست، کمک به تصمیم‌گیری بهتر کشاورز
            است
          </span>
        )}
      </p>

      <div className="flex flex-col items-center">
        <img src={srcLogo} className="m-4" alt={`${serviceType}-icon`} />
        <div className="flex flex-col items-center">
          <span
            className={`text-[${reportColorCode}] font-bold text-[44px] [text-shadow:1px_0px_3px_rgba(118,118,118,0.61)] !font-[B-Nazanin]`}
          >
            {headerTitle}
            {introDes}
          </span>
        </div>
      </div>
    </>
  );
}

export default Intro;
